<template>
  <div class="rmzxrmht between">
    <div class="rmhtlef">
      <div class="head between">
        <sub-title text="热门话题推荐" />
        <div class="hyp flex_start">
          <img src="../../../assets/laws/huanyipi.png" /> 换一批
        </div>
      </div>
      <div class="zcnrbf between mt30">
        <div class="zcydt">
          <div class="zcwzcov">
            <img src="../../../assets/hotconsult/zxcover_sample.png" alt="" />
          </div>
          <div class="zcwznr">
            <div class="rmzxzcname ellipsis">离婚后探视权怎么规定的</div>
            <div class="zclabe flex_start">
              <div>2020.04.30 16:12</div>
              <div>探视权</div>
              <div class="flex_start">
                <img src="../../../assets/base/kan.png" />12345 浏览
              </div>
            </div>
          </div>
        </div>
        <div class="ycsxt between wrap">
          <div class="yclitem" v-for="item in 4" :key="item">
            <div class="ycitcov">
              <img src="../../../assets/hotconsult/zxcover_sample.png" alt="" />
            </div>
            <div class="ycitname ellipsis">离婚后探视权怎么规定的</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rmhtrig a">
      <sub-title text="合肥最新入驻律所" />
      <div class="rmriglist">
        <div
          class="rmrigitem flex_start"
          v-for="(item, index) in 9"
          :key="index"
          @mouseover="itemact = index"
          :class="{ latestinact: itemact == index }"
        >
          <div class="left">
            <div class="cove">
              <img
                src="../../../assets/hotconsult/wzarticcove_sample.png"
              />
            </div>
            <div
              class="sortp center"
              :class="{
                sortp1: index == 0,
                sortp2: index == 1,
                sortp3: index == 2,
              }"
            >
              {{ item }}
            </div>
          </div>
          <div class="infotext">
            <div class="ycwzbt ellipsis">
              上海锦天城锦天城（合肥）律师事务所
            </div>
            <div class="ycwzjj">
              {{
                `在道路交通事故中，有部分 汽车驾驶员因为不
              在道路交通事故中，有部分 汽车驾驶员因为不` | toEllipsisFilter(22)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data: () => ({
    itemact: 0,
  }),
};
</script>

<style lang="scss" scoped>
.rmzxrmht {
  align-items: flex-start;
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .rmhtlef {
    width: 855px;
    .head {
      .hyp {
        font-size: 14px;
        color: #0380fc;
        margin-right: 10px;
        cursor: pointer;
        img {
          margin-right: 5px;
        }
      }
    }
    .zcnrbf {
      align-items: flex-start;
      .zcydt {
        cursor: pointer;
        width: 395px;
        height: 364px;
        background: #ffffff;
        box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
        .zcwzcov {
          img {
            width: 395px;
            height: 260px;
          }
        }
        .zcwznr {
          padding: 20px;
          .rmzxzcname {
            font-size: 20px;
            color: #333333;
          }
          .zclabe {
            font-size: 14px;
            color: #999999;
            margin-top: 15px;
            > div {
              margin-right: 20px;
            }
            img {
              width: 15px;
              height: 11px;
              margin-right: 5px;
            }
          }
        }
      }
      .ycsxt {
        width: 430px;
        height: 364px;
        .yclitem {
          cursor: pointer;
          width: 200px;
          height: 174px;
          background: #fff;
          margin-bottom: 18px;
          box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
          .ycitcov {
            img {
              width: 200px;
              height: 134px;
            }
          }
          .ycitname {
            padding: 12px 10px;
            font-size: 12px;
            color: #333333;
          }
        }
      }
    }
  }
  .rmhtrig {
    width: 315px;
    padding: 16px 12px 0;
    box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.07);
    .rmriglist {
      padding: 10px 0 18px;
      .rmrigitem {
        margin-top: 15px;
        .left {
          .sortp {
            color: #fff;
            margin-right: 10px;
            width: 20px;
            height: 20px;
            background: #CCCCCC;
            border-radius: 2px;
            font-size: 12px;
          }

          .sortp1 {
            background-color: #ff6600;
            color: #fff;
          }
          .sortp2 {
            background-color: #ff8b3e;
            color: #fff;
          }
          .sortp3 {
            background-color: #f4ab2b;
            color: #fff;
          }
          .cove {
            display: none;
            img {
              width: 95px;
              height: 55px;
              margin-right: 6px;
            }
          }
        }

        .infotext {
          width: 240px;
          .ycwzbt {
            font-size: 14px;
            color: #666666;
            line-height: 14px;
          }
          .ycwzjj {
            display: none;
            font-size: 12px;
            color: #999999;
            margin-top: 6px;
            line-height: 18px;
          }
        }
        &.latestinact {
          .left {
            .sortp {
              display: none;
            }
            .cove {
              display: block;
            }
          }
          .infotext {
            width: 170px;
            .ycwzjj {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>